import api from './api';

export const bankAccountService = {
  async getBanks() {
    const response = await api.get('/bank-account/banks');
    return response.data;
  },

  async resolveAccount(accountNumber, bankCode) {
    const response = await api.post('/bank-account/resolve', { accountNumber, bankCode });
    return response.data;
  },

  async getPharmacyBankAccount() {
    const response = await api.get('/bank-account/pharmacy');
    return response.data;
  },

  async updatePharmacyBankAccount(bankAccount) {
    const response = await api.put('/bank-account/pharmacy', bankAccount);
    return response.data;
  },

  async getRiderBankAccount() {
    const response = await api.get('/bank-account/rider');
    return response.data;
  },

  async updateRiderBankAccount(bankAccount) {
    const response = await api.put('/bank-account/rider', bankAccount);
    return response.data;
  }
};

export default bankAccountService;
